import { isMobile as isMobileUserAgent, preventOneWordInLastLine } from '@lemonade-hq/cdk';
import { useMemo } from 'react';
import type { PropsWithChildren, ReactNode } from 'react';
import { Drawer } from '../Drawer/Drawer';
import { Text } from '../Text/Text';
import { Tooltip } from '../Tooltip/Tooltip';
import type { TooltipProps } from '../Tooltip/Tooltip';
import { mobileTooltip } from './Tooltip.css';

export interface IsomorphicTooltipProps extends TooltipProps {
  readonly mobileContent?: ReactNode;
}

export const IsomorphicTooltip: React.FC<PropsWithChildren<IsomorphicTooltipProps>> = ({
  content,
  children,
  mobileContent,
  ...restProps
}) => {
  const isMobile = useMemo(() => isMobileUserAgent(), []);

  if (isMobile) {
    return (
      <Drawer.Root>
        <Drawer.Trigger>{children}</Drawer.Trigger>
        <Drawer.Content className={mobileTooltip} description={content} title={content}>
          <Text textAlign="center" type="bodyMedium">
            {mobileContent ?? preventOneWordInLastLine(content)}
          </Text>
        </Drawer.Content>
      </Drawer.Root>
    );
  }

  return (
    <Tooltip content={content} {...restProps}>
      {children}
    </Tooltip>
  );
};
